import { motion, AnimatePresence } from "framer-motion";
import ArrowOpen from "../../../svg/ArrowOpen";
import ArrowClose from "../../../svg/ArrowClose";
import { ownerData } from "../../../data/main.data";
import SocialCard from "./SocialCard";

function SectionCard({ sectionData, activeId, setActive }: any) {
  const { id, name, description, content, isWorks, isSocials } = sectionData;

  return (
    <div
      key={id}
      role="button"
      onClick={() => setActive(activeId === id ? null : id)}
      className={`${
        activeId === id && "flex flex-col"
      } border-b border-gray-500 py-3 md:py-5 w-full transition-all font-boska`}
    >
      <div className="flex items-center justify-between w-full">
        <div
          className={`${
            activeId !== id && "hover:cursor-pointer md:hover:scale-105"
          } flex justify-start items-center duration-300 ease-linear`}
        >
          <p className="text-xl md:text-3xl font-black text-black">{name}</p>
          {activeId === id ? <ArrowClose /> : <ArrowOpen />}
        </div>
      </div>

      <div className="w-full h-fit overflow-hidden">
        <AnimatePresence mode="wait">
          {activeId === id && (
            <motion.div
              initial={{
                height: 0,
                opacity: 0,
              }}
              animate={{
                height: "auto",
                opacity: 1,
                transition: {
                  height: {
                    duration: 0.4,
                  },
                  opacity: {
                    duration: 0.25,
                    delay: 0.15,
                  },
                },
              }}
              exit={{
                height: 0,
                opacity: 0,
                transition: {
                  height: {
                    duration: 0.4,
                  },
                  opacity: {
                    duration: 0.25,
                  },
                },
              }}
              className="overflow-hidden w-full"
            >
              {
                //text or art or socials
                // isWorks ? (
                //   // <p>{artProjects[0].name}</p>
                //   artProjects.length > 0 ? (
                //       <Marquee pauseOnHover={true} gradient={false} className="flex justify-start items-center pt-5">
                //       {
                //         artProjects.map((art: any, index: any) => {
                //           return (
                //             <ProjectCard key={index} data={art}/>
                //           );
                //         })
                //       }
                //       </Marquee>
                //   ) : (
                //     <p className="text-black text-lg md:text-xl font-light pt-4">
                //       Loading Art Projects!
                //     </p>
                //   )
                // ) :

                isSocials ? (
                  <div>
                    <p className="text-black text-lg md:text-xl font-thin pt-4">
                      {description}
                    </p>
                    {ownerData.socials.map((socialData: any, index: any) => {
                      return <SocialCard key={index} socialData={socialData} />;
                    })}
                  </div>
                ) : (
                  <div className="text-black text-lg md:text-xl font-light pt-4">
                    {content.map((element: any, index: any) => {
                      return <div key={index}>{element}</div>;
                    })}
                  </div>
                )
              }
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}

export default SectionCard;
